import { ClickEvent } from "@mcleod/components";
import { AutogenLayoutSCACCarrierQuickInfo } from "./autogen/AutogenLayoutSCACCarrierQuickInfo";
import { Navigation } from "@mcleod/core";

export class SCACCarrierQuickInfo extends AutogenLayoutSCACCarrierQuickInfo {

    imageDetailLinkOnClick(event: ClickEvent) {
        const payeeId = this.activeRow?.get("payee.id");
        Navigation.navigateTo("lme/dispatch/Carrier?mode=update&key=" + payeeId, {newTab: true});
    }
}
